import dialogMixin from "@/mixin/dialogMixin";
import listMixin from "@/mixin/listMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import { noZero } from "@/utils/check";
import { monthlyEndPower, monthlyMoney } from "@/utils/monthlyTemplatecheck";

export default {
    mixins: [resDisposeMixin, dialogMixin, listMixin],
    computed: {
        listStart() {
            return (index) => {
                let len = this.params.monthlyInfoList.length;
                return index === len - 1;
            }
        },
        listEnd() {
            return (index) => {
                let len = this.params.monthlyInfoList.length;
                return index !== 0 && index === len - 1;
            }
        }
    },
    data() {
        return {
            rules: {
                name: [{required: true, message: '请输入模板名称'}],
                money: [
                    {required: true, message: '请输入金额'},
                    {validator: monthlyMoney}
                ],
                day: [
                    {required: true, message: '请输入天数'},
                    {type: 'number', message: '天数必须为数字值'},
                    {validator: noZero}
                ],
                chi: [
                    {required: true, message: '请输入小时'},
                    {type: 'number', message: '小时必须为数字值'},
                    {validator: noZero}
                ],
                endPower: [
                    {required: true, message: '请输入瓦数',},
                    {type: 'number', message: '瓦数必须为数字值'},
                    {validator: monthlyEndPower.bind(this)},
                ]
            },
            params: {
                name: undefined,
                monthlyInfoList: [{
                    startPower: 0,
                    endPower: undefined,
                    freeChargeNum: undefined,
                    freeDayNum: undefined,
                    money: undefined,
                }]
            },
        }
    },
    methods: {
        addItem(item) {
            this.$refs['params'].validate((valid) => {
                if (valid) {
                    this.params.monthlyInfoList.push(
                        {
                            money: undefined,
                            freeDayNum: undefined,
                            freeChargeNum: undefined,
                            startPower: item.endPower,
                            endPower: undefined,
                        }
                    )
                }
            })
        },
    }
}